export default "__VITE_ASSET__CNVUo$83__"